module.exports = __webpack_public_path__ + "static/media/cat-tip.05f302c0.jpg";